import { render, staticRenderFns } from "./MetaDataHeadBar.vue?vue&type=template&id=51a7e02a&scoped=true&"
import script from "./MetaDataHeadBar.vue?vue&type=script&lang=js&"
export * from "./MetaDataHeadBar.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataHeadBar.vue?vue&type=style&index=0&id=51a7e02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a7e02a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a7e02a')) {
      api.createRecord('51a7e02a', component.options)
    } else {
      api.reload('51a7e02a', component.options)
    }
    module.hot.accept("./MetaDataHeadBar.vue?vue&type=template&id=51a7e02a&scoped=true&", function () {
      api.rerender('51a7e02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/MetaDataHeadBar.vue"
export default component.exports